import { SOCKET_EVENTS } from '@constants';
import { IRequestSectionReview } from '@sdk/contracts';
import { useEffect } from 'react';

import { useSocket, useSectionReviewModal } from '@/hooks';

export const SectionReviewHandler = () => {
  const { on, off } = useSocket();
  const { setSectionIdToReview, setSectionCourseId } = useSectionReviewModal();

  useEffect(() => {
    const onRequestSectionReview = ({ sectionId, courseId }: IRequestSectionReview) => {
      setSectionIdToReview(sectionId);
      setSectionCourseId(courseId);
    };
    on(SOCKET_EVENTS.REQUEST_SECTION_REVIEW, onRequestSectionReview);
    return () => off(SOCKET_EVENTS.REQUEST_SECTION_REVIEW, onRequestSectionReview);
  }, [on, off, setSectionIdToReview, setSectionCourseId]);

  return <></>;
};
